module.exports = __webpack_public_path__ + "assets/img/slide03.f97f4011.svg";